import { formDataRequest, postRequest } from '../libs/AxiosService.util';

export async function serviceCreateSideEffects(params) {
    return await formDataRequest('side/effects/create', params);
}

export async function serviceUpdateSideEffects(params) {
    return await formDataRequest('side/effects/update', params);
}

export async function serviceGetSideEffects(params) {
    return await postRequest("side/effects", params);
}

export async function serviceSideEffectsDetail(params) {
    return await postRequest("side/effects/detail", params);
}
export async function serviceDeleteSideEffects(params) {
    return await postRequest("side/effects/delete", params);
}

export async function serviceSideEffectsIsExist (params) {  
    return await postRequest('side/effects/check', params);
}
export async function serviceExportSideEffects (params) {  
    return await postRequest('side/effects/export', params);
}